// src/layouts/Pages/PageHeader/CardHeaderColumns/items/genderSegment.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { ManOutlined, ShopOutlined, UserOutlined, WomanOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const genderSegmentItem = record => {
  const isCompany = !!(record?.cnpj?.value || record?.foundedAt);

  // Dynamic icon based on entity type
  const SegmentIcon = <ShopOutlined />;
  const GenderIcon =
    record?.gender?.toLowerCase() === 'male' ? (
      <ManOutlined />
    ) : record?.gender?.toLowerCase() === 'female' ? (
      <WomanOutlined />
    ) : (
      <UserOutlined />
    );

  // Label: gender for person, segment for company
  const label = translateX(
    record?.gender?.toLowerCase() ||
      (record?.segment && `segments_code.${record?.segment?.toLowerCase()}`)
  );

  return {
    key: 'gender',
    icon: isCompany ? SegmentIcon : GenderIcon,
    label: label,
    tooltipText: translateX(isCompany ? 'segment' : 'gender'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export default genderSegmentItem;
